import { Link } from "react-router-dom";
import { useSettings } from "@/lib/settings";
import { useLocalizedSettings } from "@/lib/localizedSettings";
import { useT } from "@/lib/i18n";
import BrandName from "@/components/BrandName";
import LanguageToggle from "@/components/LanguageToggle";

export default function Header() {
  const s = useLocalizedSettings();
  const t = useT();
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full border-b border-white/10 bg-black/60 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:gap-4 sm:px-6 sm:py-4 lg:px-10">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex min-w-0 items-center gap-2 sm:gap-3"
        >
          {s.logo_url ? (
            <img
              src={s.logo_url}
              alt={s.workshop_name}
              className="h-10 max-w-[60px] object-contain sm:h-16 sm:max-w-[120px] lg:h-20"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          ) : null}
          <BrandName
            name={s.workshop_name}
            size="sm"
            testId="header-brand"
          />
          {s.tagline && (
            <div className="mono ml-3 hidden text-[10px] uppercase tracking-[0.2em] text-white/50 lg:block">
              {s.tagline}
            </div>
          )}
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          <a
            href="/#services"
            data-testid="nav-services"
            className="text-sm text-white/70 transition-colors hover:text-white"
          >
            {t("nav.services")}
          </a>
          <a
            href="/#kontakt"
            data-testid="nav-contact"
            className="text-sm text-white/70 transition-colors hover:text-white"
          >
            {t("nav.contact")}
          </a>
        </nav>

        <div className="flex flex-shrink-0 items-center gap-2 sm:gap-3">
          <LanguageToggle />
          <Link
            to="/buchen"
            data-testid="header-book-btn"
            className="whitespace-nowrap bg-[#FF4B00] px-3 py-2 text-[11px] font-semibold uppercase tracking-wider text-white transition-colors hover:bg-[#E64300] sm:px-5 sm:py-2.5 sm:text-sm"
          >
            {t("cta.book")}
          </Link>
        </div>
      </div>
    </header>
  );
}
